
    <div *ngIf="selectOpen" style="width:100%;height:100%;position:fixed;top:0;left:0;z-index:99;background-color: #00000055;" (click)="toggleSelect()"></div>

    <!-- <span [title]="section.uuid">*</span> -->

    <ng-container *ngIf="section.type == 'process'">
        PROCESS --> {{ section.action }}
    </ng-container>
    <!-- <ng-container *ngIf="section.type == 'progress'">
        <mat-progress-bar style="margin:1px 5px 5px 5px;width:300px;" mode="determinate" [value]="section.value" color="accent"></mat-progress-bar> {{section.value | percent }}%
    </ng-container> -->
    <ng-container *ngIf="section.type == 'clear'">
        <div class="clearfix"></div>
    </ng-container>
    <ng-container *ngIf="section.type == 'loading'">
        <div style="text-align:center;width:100%;height:23vh;top:16vh;position:absolute;left:-36vw;z-index:9999;background-color: #ffffff55;border-radius: 10px;padding-top: 5vh;">
            <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
            <div style="margin-top:10px;font-size:14px;">{{ 'GENERIC.LOADING' | translate }} ...</div>
        </div>
    </ng-container>
    <ng-container *ngIf="section.type == 'info'">
        <span style="color:#666;font-size:11px;">
            <ng-container *ngIf="section['translateValue']">{{ section.value | translate:section.translateParams }} </ng-container>
            <ng-container *ngIf="!section['translateValue']">{{ section.value }} </ng-container>
            <span *ngIf="section.extra">
                <ng-container *ngIf="section['translateExtra']">{{ section.extra | translate }} </ng-container>
                <ng-container *ngIf="!section['translateExtra']">{{ section.extra }} </ng-container>
            </span>
        </span>
        <fa-icon *ngIf="section.options" icon="info" class="fdm-icon fdm-linked" style="margin-left:10px;color:blue;" (click)="showOptions(section);"></fa-icon>
    </ng-container>
    <ng-container *ngIf="section.type == 'coord' && section.value">
        <span class="mini-label">{{ 'MAP.LATITUDE' | translate }}</span> {{ section.value.lat }} <br>
        <span class="mini-label">{{ 'MAP.LONGITUDE' | translate }}</span> {{ section.value.long }} <br>
        <span class="mini-label">{{ 'GENERIC.HEIGHT' | translate }}</span> {{ section.value.height | qmap_round }}
    </ng-container>
    <ng-container *ngIf="section.type == 'plain'">
        {{ section.value }}<span *ngIf="section.text_token">{{ section.text_token }}</span>
    </ng-container>
    <ng-container *ngIf="section.type == 'text-editor'">
        <textarea style="width:100%;height:80px;font-size:9px;" [(ngModel)]="section.value">{{ section.value }}</textarea>
    </ng-container>
    <ng-container *ngIf="section.type == 'heading'">
        <h5>{{ section.value | translate }} <span *ngIf="section.text_token">{{ section.text_token }}</span></h5>
    </ng-container>
    <ng-container *ngIf="section.type == 'alert'">
        <span class="alert-danger" style="white-space:normal">{{ section.value | translate }} <span *ngIf="section.text_token">{{ section.text_token }}</span></span>
    </ng-container>
    <ng-container *ngIf="section.type == 'note'">
        <span class="alert-warning" style="white-space:normal">{{ section.value | translate }} <span *ngIf="section.text_token">{{ section.text_token }}</span></span>
    </ng-container>


    <ng-container *ngIf="section.type == 'button'">
        <button mat-flat-button [color]="section.style" [class]="'fdm-button ' + section['class']" style="height:26px;line-height:14px!important;margin:2px 2px 2px 0;background-color:cornflowerblue;color:#fff;" 
            (click)="plugin[section.action](section)">
            <fa-icon *ngIf="section['icon']" [icon]="section['icon']" style="margin-right:5px;"></fa-icon>
            <!-- <ng-container *ngIf="section.value">{{ section.value }}</ng-container> -->
            <ng-container *ngIf="section.text_token">{{ section.text_token  | translate }}</ng-container>
            <ng-container *ngIf="!section.text_token">{{ section.name | translate }}</ng-container>
        </button>
        <ng-container *ngIf="section.plugConfig && plugin.plugs && plugin.plugs[section.plugConfig]">
            <ng-container *ngFor="let config of [plugin.plugs[section.plugConfig]]">
                <span class="fdm-button-plugin-ui fdm-linked" (click)="config.show = !config.show">
                    <fa-icon icon="cog" *ngIf="config.object"></fa-icon>
                    {{ 'PLUGIN.CONFIG' | translate }}
                </span>
            </ng-container>
        </ng-container>
    </ng-container>
    
    <ng-container *ngIf="section.type == 'slider'">
        <span [class]="section['class']">
            <mat-slider color="primary" style="width:130px"
                class="fdm-layer-slider" [min]="section.min" [max]="section.max" [step]="section.step"
                [(ngModel)]="section.value" (change)="plugin.refresh();plugin.save();" (input)="plugin.refresh($event.value,section);"
            ></mat-slider> <input type="number" [min]="section.min" [max]="section.max" [step]="section.step" [(ngModel)]="section.value" [style]="section.valueWidth ? 'width:40px':''" class="lookLikeText" (change)="plugin.refresh();plugin.save();" />
            <span *ngIf="section.valuePost">{{ section.valuePost }}</span>
            <span *ngIf="section.modelValue" class="fdm-plugin-controls-smalltext">({{ section.modelValue }})</span>
        </span>
    </ng-container>
    <ng-container *ngIf="section.type == 'range'">
        <input type="number" class="fdm-range-number" [(ngModel)]="section.from" [value]="section.from" [max]="section.to" (change)="plugin.refresh();plugin.save();">
        <span *ngIf="section.fromPost">{{ section.fromPost }}</span> 
        <span *ngIf="section.fromModelValue" class="fdm-plugin-controls-smalltext">({{ section.fromModelValue }}<span *ngIf="section.fromPost">{{ section.fromPost }}</span>)</span>
        - <input type="number" class="fdm-range-number" [(ngModel)]="section.to" [value]="section.to" [min]="section.from" (change)="plugin.refresh();plugin.save();">
        <span *ngIf="section.toPost">{{ section.toPost }}</span> 
        <span *ngIf="section.toModelValue" class="fdm-plugin-controls-smalltext">({{ section.toModelValue }}<span *ngIf="section.toPost">{{ section.toPost }}</span> )</span>
    </ng-container>

    <ng-container *ngIf="section.type == 'number'">
        <input type="number" [(ngModel)]="section.value" [value]="section.value" [min]="section.min" [max]="section.max" [step]="section.step" (change)="plugin.refresh();plugin.save();"> 
        <span *ngIf="section.modelValue" class="fdm-plugin-controls-smalltext">({{ section.modelValue }})</span>
        <span style="font-size:9px;margin-left:5px;color:#777;" *ngIf="section.optional">({{ 'FORMS.OPTIONAL' | translate }})</span>
    </ng-container>
    <ng-container *ngIf="section.type == 'text'"><input type="text" class="fdm-expand-on-focus-hidden" />
        <input type="text" [(ngModel)]="section.value" class="fdm-expand-on-focus" [value]="section.value"> 
        <span *ngIf="section.modelValue" class="fdm-plugin-controls-smalltext">({{ section.modelValue }})</span>
        <span style="font-size:9px;margin-left:5px;color:#777;" *ngIf="section.optional">({{ 'FORMS.OPTIONAL' | translate }})</span>
    </ng-container>
    <ng-container *ngIf="section.type == 'url'"><input type="text" class="fdm-expand-on-focus-hidden" />
        <input type="url" [(ngModel)]="section.value" [value]="section.value" class="fdm-expand-on-focus"> 
        <span *ngIf="section.modelValue" class="fdm-plugin-controls-smalltext">({{ section.modelValue }})</span>
        <span style="font-size:9px;margin-left:5px;color:#777;" *ngIf="section.optional">({{ 'FORMS.OPTIONAL' | translate }})</span>
    </ng-container>

    <ng-container *ngIf="section.type == 'check'">
        <mat-slide-toggle color="primary" [checked]="section.value" [(ngModel)]="section.value" (change)="plugin.refresh();plugin.save();"></mat-slide-toggle>
        <span *ngIf="section.info" style="margin-left:27px;color:#888;font-size:10px;">
            {{ section.info }}
        </span>
        <ng-container *ngIf="section.plugConfig && plugin.plugs && plugin.plugs[section.plugConfig]">
            <ng-container *ngFor="let config of [plugin.plugs[section.plugConfig]]">
                <span class="fdm-button-plugin-ui fdm-linked" (click)="config.show = !config.show">
                    <fa-icon icon="cog" *ngIf="config.object"></fa-icon>
                    {{ 'PLUGIN.CONFIG' | translate }}
                </span>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="section.type == 'toolbar'">
        <div class="fdm-icons-toolbar">
            <fa-icon *ngFor="let i of section.items" [icon]="i.icon" (click)="plugin[i.action](section)"></fa-icon>
        </div>
    </ng-container>

    <ng-container *ngIf="section.type == 'colorbar'">
        <div class="colors" style="height:30px;width:200px;" [style.background]="plugin.linearScale('__current')"></div>
    </ng-container>

    <ng-container *ngIf="section.type == 'legend'">
        <div class="fdm-legendary">

            <div *ngIf="section.renderMode == 'valuecheck'" class="colors" [style.background]="plugin.linearScale()" [style.height]="plugin.linearScaleHeight(3)"></div>
            <div *ngIf="section.renderMode == 'valuecheck' && section.showThreshold && section.hasThreshold" class="threshold" [style.height]="plugin.linearScaleHeight(3)">
                <div *ngIf="section.thresholdPercent" class="marker" [style.top]="plugin.linearScaleY(section.threshold,3)+'px'">{{ section.threshold }}%</div>
                <div *ngIf="!section.thresholdPercent" class="marker" [style.top]="plugin.linearScaleY(section.threshold,3)+'px'">{{ getLocalisedValue(section.threshold) }}</div>
            </div>
            
            <div *ngIf="section.renderMode == 'colormap'" class="title">{{ section?.property?.toUpperCase() }}</div>
            
            <div class="data">
                <table [style.height]="section.renderMode == 'valuecheck' ? plugin.linearScaleHeight(3) : 'auto'">
                    <tr *ngFor="let i of section.items; let idx = index;">

                        <td *ngIf="section.renderMode == 'valuecheck'" class="color" [style]="sanitizer.bypassSecurityTrustStyle('height:'+plugin.linearScaleHeight(3,i.size)+';')">
                            <ng-container *ngIf="section.mode == 'elevation'">
                                <div class="max" *ngIf="idx == 0 && section.showMinMaxValues">{{ getLocalisedValue(section.max) }}</div>
                                <div *ngIf="section.showRangeHeightValues">{{ getLocalisedValue(i.height) }}</div>
                                <div class="min" *ngIf="idx == section.items.length - 1 && section.showMinMaxValues">{{ getLocalisedValue(section.min) }}</div>
                            </ng-container>
                            <ng-container *ngIf="section.mode == 'slope'">
                                <div *ngIf="section.showRangeHeightValues">{{ rounding(100 - (idx * 11.11)) }}%</div>
                            </ng-container>
                            <ng-container *ngIf="section.mode == 'aspect'">
                                <div *ngIf="section.showRangeHeightValues">{{ idx * 12.5 }}&deg;</div>
                            </ng-container>
                        </td>
                        <td *ngIf="section.renderMode == 'colormap'" class="color" [style]="sanitizer.bypassSecurityTrustStyle('background-color:'+i.color+';height:'+i.size+'px;vertical-align:middle;margin-bottom:2px;')">
                        </td>

                        <td *ngIf="section.showRangeLabels && i.label" class="label" style="padding:10px;">
                            <span *ngIf="section.mode == 'elevation'">{{ 'COLORS.MODELS.'+i.label | translate }}</span>
                            <span *ngIf="section.mode == 'slope'">{{ i.label | translate }}&deg;</span>
                            <span *ngIf="section.mode == 'aspect'">{{ i.label | translate }}</span>
                        </td>


                        <!-- <td class="color" [style]="sanitizer.bypassSecurityTrustStyle('height:'+(i.size*3)+'px;border:solid 2px yellow !important;')">
                            <div *ngIf="idx == 0" style="border-bottom:dotted 1px #ffffff55;">{{ i.max }}max</div>
                            <div>{{ i.height }}m</div>
                            <div *ngIf="idx == section.items.length - 1" style="border-top:dotted 1px #ffffff55;">{{ i.min }}min</div>
                        </td>
                        <td class="label" [style]="sanitizer.bypassSecurityTrustStyle('height:'+(i.size*3)+'px;border:solid 2px pink !important;')">{{ i.label }}</td> -->
                    </tr>
                </table>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="section.type == 'radio'">
        <div class="fdm-select-list fdm-linked">
            <ng-container *ngFor="let aa of section.options">
                <span (click)="radioSelect(aa,section)">
                    <input type="radio" [name]="section.uuid" [value]="aa" [checked]="aa == section.value"  style="margin-left:10px;margin-right:3px;" />
                    <ng-container *ngIf="section.translateOptions">{{ (plugin?.meta?.translator ? plugin.meta.translator + '.' + aa : aa) | translate }}</ng-container>
                    <ng-container *ngIf="!section.translateOptions">{{ aa }}</ng-container>
                </span>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="section.type == 'select'">
        <mat-form-field *ngIf="!section.colorbar && !section.advancedOptions" appearance="none">
            <mat-select [(ngModel)]="section.value" (ngModelChange)="plugin.refresh();plugin.save();">
                <mat-option *ngFor="let aa of section.options" [value]="aa" [class.fdm-color-band-label]="section.optionType && section.optionType == 'colors'">
                    <ng-container *ngIf="!section.optionType">
                        <ng-container *ngIf="section.translateOptions">{{ (plugin?.meta?.translator ? plugin.meta.translator + '.' + aa : aa) | translate }}</ng-container>
                        <ng-container *ngIf="!section.translateOptions">{{ aa }}</ng-container>
                    </ng-container>
                    <ng-container *ngIf="section.optionType && section.optionType == 'colors'">
                        <div *ngIf="aa == 'none'" class="fdm-color-band-label">-- {{ 'GENERIC.NONE' | translate }} --</div>
                        <div *ngIf="aa !== 'none'" [style.background]="plugin.linearScale(aa)" class="fdm-color-band-label">{{ 'COLORS.MODELS.'+aa.toUpperCase() | translate }}</div>
                    </ng-container>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="!section.colorbar && section.advancedOptions">
            <mat-select [(ngModel)]="section.value" (ngModelChange)="plugin.refresh();plugin.save();">
                <mat-select-trigger>
                    <span *ngIf="section.value" style="display:inline-block;width:120px;padding:2px 4px;">
                        <ng-container *ngIf="section.translateOptions || section.value == 'none'">{{ (plugin?.meta?.translator ? plugin.meta.translator + '.' + section.value : section.value) | translate }}</ng-container>
                        <ng-container *ngIf="!section.translateOptions && section.value !== 'none'">{{ section.value }}</ng-container>
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let obj of section.advancedOptions" [value]="obj.value" [class.fdm-color-band-label]="section.optionType && section.optionType == 'colors'">
                    <ng-container *ngIf="!section.optionType">
                        <span *ngIf="obj.value" style="display: inline-block;width:120px;">
                            <ng-container *ngIf="section.translateOptions || obj.value == 'none'">{{ (plugin?.meta?.translator ? plugin.meta.translator + '.' + obj.value : obj.value) | translate }}</ng-container>
                            <ng-container *ngIf="!section.translateOptions && obj.value !== 'none'">{{ obj.value }}</ng-container>
                        </span>
                        <span style="display: inline-block;color:rgb(127, 151, 132);">
                            <span *ngIf="obj.unique">{{ obj.unique }} unique &nbsp;</span>
                            <span *ngIf="obj.type">{{ obj.type }}s</span>
                        </span>
                        
                    </ng-container>
                    <ng-container *ngIf="section.optionType && section.optionType == 'colors'">
                        <div *ngIf="obj.value == 'none'" class="fdm-color-band-label">-- {{ 'GENERIC.NONE' | translate }} --</div>
                        <div *ngIf="obj.value !== 'none'" [style.background]="plugin.linearScale(obj.value)" class="fdm-color-band-label">{{ 'COLORS.MODELS.'+obj.value.toUpperCase() | translate }}</div>
                    </ng-container>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <ng-container *ngIf="section.colorbar">
            <div class="colors fdm-linked" style="height:30px;width:200px;" [style.background]="plugin.linearScale('__current')" (click)="toggleSelect()">
                <fa-icon icon="chevron-down" style="float: right;color: #fff;margin-right: 10px;margin-top: 5px;"></fa-icon>
                <div *ngIf="section.value == 'none'" class="fdm-color-band-label">-- {{ 'GENERIC.NONE' | translate }} --</div>
                <div *ngIf="section.value !== 'none'" [style.background]="plugin.linearScale(section.value)" class="fdm-color-band-label">{{ 'COLORS.MODELS.'+section.value.toUpperCase() | translate }}</div>
            </div>
            <div *ngIf="selectOpen" class="fdm-select-open" style="top:30px;width:300px;position:absolute;height:auto;min-height:100px;z-index:999;background-color:#fff;padding:1px 2px; border: solid 3px #e0bb1c; box-shadow: 0 0 280px 10px #223;">
                <div class="fdm-select-list fdm-linked" *ngFor="let aa of section.options" [class.fdm-color-band-label]="section.optionType && section.optionType == 'colors'">
                    <ng-container *ngIf="!section.optionType">
                        <span (click)="toggleSelect(aa,section)">{{ section.name + '_' + aa | translate }}</span>
                    </ng-container>
                    <ng-container *ngIf="section.optionType && section.optionType == 'colors'">
                        <div *ngIf="aa == 'none'" class="fdm-color-band-label" (click)="toggleSelect(aa,section)">-- {{ 'GENERIC.NONE' | translate }} --</div>
                        <div *ngIf="aa !== 'none'" [style.background]="plugin.linearScale(aa)" class="fdm-color-band-label" (click)="toggleSelect(aa,section)">{{ 'COLORS.MODELS.'+aa.toUpperCase() | translate }}</div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="section.icons">
            <ng-container *ngFor="let b of section.icons">
                <fa-icon [icon]="b[1]" class="fdm-icon-plugin-action" (click)="plugin['incomingAction'](b[0],section)" [matTooltip]="b[0]"></fa-icon>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="section.type == 'actions'">
        <ng-container *ngIf="section.icons">
            <ng-container *ngFor="let b of section.icons">
                <fa-icon [icon]="b[1]" class="fdm-icon-plugin-action" (click)="plugin['incomingAction'](b[0],section)"  matTooltip="{{ (plugin?.meta?.translator ? plugin.meta.translator + '.' + b[0] : b[0]) | translate }}"></fa-icon>
                <!--  matTooltip="{{ (plugin?.meta?.translator ? plugin.meta.translator + '.' + b[0] : b[0]) | translate }}" -->
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="section.type == 'color'">
        <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" 
            [(colorPicker)]="section.value" 
            (colorPickerChange)="plugin.refresh();plugin.save();"
            [style.background]="section.value"  
            cpOutputFormat="rgba">
            <fa-icon icon="chevron-down"></fa-icon>
        </div>
    </ng-container>
    
    <div style="min-height:10px;min-width:10px;border:solid 1px red;" *ngIf="section.canvas" #incomingCanvasContainer></div>